<!-- <div class="health-track-container">
<div class="htc-left">
  <img [attr.src]="imgUrl">
</div>
<div class="htc-middle">
  Blood Pressure
</div>
<div class="htc-right">
  <span class="value">{{vitalVal}}</span>
</div>
</div> -->
@if (!showSkeletonLoader  && widgetName) {
  <a class="tracker w-inline-block" (click)="handleLinkClick()">
    <div class="trackhealth_div">
      <img loading="lazy" [attr.src]="imgUrl" alt="" class="tracker_image">
      <h4 class="tracker_head">{{widgetName}}</h4>
    </div>
    <div class="tracker_value"><strong class="track_bold"> {{vitalVal!=='' ? vitalVal : 'NA'}}</strong></div>
  </a>
}
@if (showSkeletonLoader) {
  <app-skeleton-loader  [height]="height"></app-skeleton-loader>
}